import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#7B5E3B', // light wood brown
    },
    secondary: {
      main: '#2E5939', // forest green
    },
    background: {
      default: '#FFFFFF', // clean white
      paper: '#FFFFFF',
    },
    text: {
      primary: '#222', // dark grey/black
      secondary: '#7B5E3B',
    },
    divider: '#F5F3E7', // subtle divider
  },
  typography: {
    fontFamily: 'Montserrat, Arial, sans-serif',
    h1: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.5px',
    },
    h2: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.5px',
    },
    h3: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 700,
    },
    h4: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 600,
    },
    body1: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 400,
    },
    body2: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 400,
    },
  },
  shape: {
    borderRadius: 4, // flat, subtle rounding
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none', // flat style
          border: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid #F5F3E7', // very subtle border
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 4,
          boxShadow: 'none',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: '2.5rem',
          paddingBottom: '2.5rem',
        },
      },
    },
  },
  spacing: 8, // generous base spacing
});

export default theme; 